import { useLocation } from "react-router-dom";

export default function useLocationState<T>() {
  const { state } = useLocation()
  return state as T | null
}